import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=5ed6f4fa&scoped=true&"
import script from "./Story.vue?vue&type=script&lang=js&"
export * from "./Story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6f4fa",
  null
  
)

export default component.exports